import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import { fonts, themes } from '../../common/themes/themes';
import { useAppSelector } from '../../infra/hooks';
import SearchComponent from '../../common/components/SearchComponent';
import CustomAddButton from '../../common/components/CustomAddButton/CustomAddButton';
import { DataGrid } from '@mui/x-data-grid';
import { useTranslate } from '../../hooks';
import { arabicDataGrid, baseDateFormatting, baseDateTimeFormatting, baseTimeFormatting, convertDateToUTC, defaultDateFormatting, time24Formatting } from '../../common/helper';
import _ from 'lodash';
import CustomModal from '../../common/Modals/CustomModal/CustomModal';
import ModalHeader from '../../common/Modals/CustomModal/ModalHeader';
import Compdirection from '../../common/themes/CompDirection';
import CustomAutoComplete from '../../common/components/CustomAutoComplete/CustomAutoComplete';
import CustomTextField from '../../common/components/CustomTextField/CustomTextField';
import ModalFooter from '../../common/Modals/CustomModal/ModalFooter';
import { DateField, DatePickerInput } from '../../components';
import { attendanceException } from '../../api/services/attendanceException';
import { colors } from '../../helpers';
import ActionButton from '../../common/components/ActionButtons/ActionButton';
import { TimePickerInput } from '../../components/inputs/TimePickerInput';
import moment from 'moment';
import toast from 'react-hot-toast';
import CardContentTile from '../../common/components/CardContentTile/CardContentTile';
import VerticalBarController from '../../common/components/VerticalBar/VerticalBarController';
import { getUtcOffsetHours } from '../../common/configs/utils';
import DropAndSelect from '../../common/components/DropAndSelect/DropAndSelect';
import { DigitalSignature } from '../../api/services/digitalSignatureService';
import ImageModelView from '../../common/components/ImageViewer/ImageModelView';
interface Propval {
  trans: any;
  i18n: any;
}
const AttendanceexceptionPresenter = ({ trans, i18n }: Propval) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);
  const { isRTL, translate } = useTranslate();
  const selector = useAppSelector((state) => state);
  const [openModel, closeModal] = useState<boolean>(false);
  const [modelHeaderName, setModalHeaderName] = useState('Add')
  const [debounceTerm, setDebounceTerm] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [attExceptionList, setattExceptionList] = useState([]);
  const [date, setDate] = useState('');
  const [markAbsent, setMarkAbsent] = useState(false);
  const [is_noShift, setIs_noShift] = useState(false);
  const [error_noshift, setErrornoshift] = useState('');
  const [shiftDetails, setShiftDetails] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [rowPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [startAt, setStartAt] = useState<any>();
  const [endAt, setEndAt] = useState(null);
  const [remarks, setRemarks] = useState('');
  const [fieldDisable, setFieldDisable] = useState(true);
  const [loading, setLoading] = useState(false)
  const [disableField, setDisableField] = useState(false)
  const [submitDisable, setSumbitDisable] = useState(true)
  const [attExceptionConfig, setAttExceptionConfig] = useState<any>([]);
  const [attConfigId, setAttConfigId] = useState<any>();
  const [attConfigName, setAttConfigName] = useState<any>();

  const [isModalOpen, closeModal2] = useState<any>(false);
  const [fullData, setFullData] = useState<any>([])

  const companyId = useAppSelector((state) => state?.authSlice?.company_id);
  const empId = useAppSelector((state) => state?.authSlice?.emp_id);

  const [newattachement, setNewAttachement] = useState(false);
  const [attExcDocumentFile, setAttExcDocumentFile] = useState<any>();
  const [attExcDocumentFilePath, setAttExcDocumentFilePath] = useState('');
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');

  const [openViewFullPicModal, setOpenViewFullPicModal] = useState(false);
  const [attachmentUrl, setAttachmenUrl] = useState('');

  const tableColumns: any = [
    {
      field: 'attExceptionType',
      headerName: trans('Attendance Exception Type'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'date',
      headerName: trans('Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'startAt',
      headerName: trans('Start At'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return params?.row?.startAt != '0000-00-00 00:00:00' ? (
          <DateField value={params.row.startAt} format={baseTimeFormatting} offset={getUtcOffsetHours(params.row.timezone)} />
        ) : (
          "--:--"
        );
      }
    },
    {
      field: 'endAt',
      headerName: trans('End At'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return params?.row?.endAt != '0000-00-00 00:00:00' && params?.row?.endAt ? (
          <DateField value={params.row.endAt} format={baseTimeFormatting} offset={getUtcOffsetHours(params.row.timezone)} />
        ) : (
          "--:--"
        );
      }
    },
    {
      field: 'remarks',
      headerName: trans('Remarks'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'status',
      headerName: trans('Status'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        switch (Number(params?.row?.status)) {
          case 0:
            return (
              <Typography
                style={{
                  color: 'brown',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#FFF8DC',
                }}
              >
                {trans('Pending')}
              </Typography>
            );

          case 1:
            return (
              <Typography
                style={{
                  color: colors.green,
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#d5fff6af',
                }}
              >
                {trans('Approved')}
              </Typography>
            );
          case 2:
            return (
              <Typography
                style={{
                  color: '#FF5263',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#ffc0c767',
                }}
              >
                {trans('Rejected')}
              </Typography>
            );
          default:
            return (
              <Typography
                style={{
                  color: '#FF5263',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#fa8c9bf5',
                }}
              >
                {trans('Pending')}
              </Typography>
            );
        }
      },
    },
    {
      field: 'action',
      headerName: trans('Action'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <ActionButton
            elements={['view']}
            View={() => handleView(params?.row?.fullData)}
          // Edit={() => handleEdit(params?.row?.fullData)}
          />
        )
      }
    },
  ];

  const row_data: any = _.map(attExceptionList, (list: any) => {
    return {
      id: list?.id,
      date: list?.date,
      startAt: list?.start_time,
      endAt: list?.end_time,
      status: list?.status,
      remarks: list?.remarks ?? '--:--',
      attExceptionType: list?.name,
      timezone: list?.timezone,
      fullData: list,
      attachment: list?.attachment
    };
  });

  const getExceptionList = () => {
    const payload = {
      company_id: companyId,
      emp_id: empId,
      page: page + 1,
      limit: rowPerPage,
      searchTerm: searchTerm
    }
    attendanceException
      .getAttendanceExceptionList(payload)
      .then((res: any) => {
        setattExceptionList(res?.data)
        setTotalCount(res?.total_count)
      })
  }

  const getAttExceptionConfig = () => {
    const payload = {
      companyId: companyId,
      configId: 45
    }
    attendanceException
      .getListAttExceptionConfig(payload)
      .then((res: any) => {
        setAttExceptionConfig(res?.data)
      })
  }

  useEffect(() => {
    getAttExceptionConfig()
  }, [])

  useEffect(() => {
    getExceptionList();
  }, [page, rowPerPage, searchTerm]);

  useEffect(() => {
    const timer = setTimeout(() => setSearchTerm(debounceTerm), 1000)
    return () => clearTimeout(timer);
  }, [debounceTerm])

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handleRowsPerPageChange = (limit: number) => {
    setRowsPerPage(limit);
    setPage(0);
  };

  const validateTime = (start: any, end: any, noShiftError: string) => {
    const isStartInvalid = start && end && moment(start, baseDateTimeFormatting).isSameOrAfter(moment(end, baseDateTimeFormatting));
    const isEndInvalid = start && end && moment(end, baseDateTimeFormatting).isSameOrBefore(moment(start, baseDateTimeFormatting));
    const isNoShift = noShiftError.length > 0;

    if (isStartInvalid || isEndInvalid) {
      toast.error("Please enter a valid time range.");
    }

    return isStartInvalid || isEndInvalid || isNoShift;
  };

  const handleChangeStartAt = (v: any) => {
    const startAtWithDate = `${moment(date).format(baseDateFormatting)} ${moment(v).format(time24Formatting)}`;
    const convertedStartDateToUTC = convertDateToUTC(startAtWithDate, baseDateTimeFormatting, getUtcOffsetHours(shiftDetails?.shift?.timezone));

    setStartAt(convertedStartDateToUTC);

    const disableSubmit = validateTime(convertedStartDateToUTC, endAt, error_noshift);
    setSumbitDisable(disableSubmit);
  };

  const handleChangeEndAt = (newValueOut: any) => {
    const endAtWithDate = `${moment(date).format(baseDateFormatting)} ${moment(newValueOut).format(time24Formatting)}`;
    const convertedEndAtDateToUTC: any = convertDateToUTC(endAtWithDate, baseDateTimeFormatting, getUtcOffsetHours(shiftDetails?.shift?.timezone));

    setEndAt(convertedEndAtDateToUTC);

    const disableSubmit = validateTime(startAt, convertedEndAtDateToUTC, error_noshift);
    setSumbitDisable(disableSubmit);
  };

  const callShiftDetails = (date: any, empid: any, companyid: any) => {
    attendanceException
      .getempshiftservicesdetails(date, empid, companyid)
      .then((res: any) => {
        setShiftDetails(res?.data);
        setFieldDisable(false)
        const disableSubmit = validateTime(startAt, endAt, "");
        setSumbitDisable(disableSubmit);
        setErrornoshift('')
      })
      .catch((err: any) => {
        toast.error(err?.error?.data);
        setErrornoshift(err?.error?.data)
        setFieldDisable(true);
        setSumbitDisable(true)
      });
  };

  const handleView = (data: any) => {
    closeModal2(true)
    setFullData(data)
  }

  const handleDateChange = (newDate: any) => {
    setStartAt('');
    setEndAt(null);
    const formattedDate = moment(newDate).format(
      defaultDateFormatting,
    );
    setDate(formattedDate);
    callShiftDetails(
      formattedDate,
      selector.authSlice.emp_id,
      selector.authSlice.company_id,
    );
  };

  const handleSubmit = (data: any) => {

    if (!attConfigId) {
      toast.error("Please select an attendance exception type.");
      return;
    }
    if (!date) {
      toast.error("Please select a date.");
      return;
    }
    if (!startAt) {
      toast.error("Please enter a start time.");
      return;
    }
    const payload: any = {
      company_id: companyId,
      emp_id: empId,
      start_time: startAt,
      end_time: endAt,
      remarks: remarks,
      date: date,
      type_id: attConfigId?.id,
      user_id: selector.adminIdSlice.adminId,
      device: 'E',
      timeZone: shiftDetails?.shift?.timezone
    }
    const findType = _.find(attExceptionConfig, (item: any) => item?.id == attConfigId?.id);
    if (findType?.is_attachment_required && !attExcDocumentFile) return toast.error('Attachment Required');

    if (attExcDocumentFile) {
      const formData = new FormData();
      setLoading(true)
      formData.append('event', 'attendanceException');
      formData.append('attachment', attExcDocumentFile);
      DigitalSignature
        .uploadSignature(formData, companyId)
        .then((attachment: any) => {
          const payloadv2 = {
            ...payload,
            attachment: attachment?.data,
          };
          attendanceException
            .createAttendanceExceptionRequest(payloadv2)
            .then((res: any) => {
              toast.success(res?.message)
              setLoading(false)
              handleClose()
              getExceptionList()
            })
            .catch((err: any) => {
              setLoading(false)
              closeModal(true)
            })
        }).catch((err: any) => {
          setLoading(false)
          closeModal(true)
        })
    } else {
      setLoading(true)
      attendanceException
        .createAttendanceExceptionRequest(payload)
        .then((res: any) => {
          toast.success(res?.message)
          setLoading(false)
          handleClose()
          getExceptionList()
        })
        .catch((err: any) => {
          setLoading(false)
          closeModal(true)
        })
    }
  }

  const handleClose = () => {
    closeModal(false)
    setDate('')
    setStartAt('')
    setEndAt(null)
    setRemarks('')
    setDisableField(false)
    setModalHeaderName('Add')
    setShiftDetails([])
    setFieldDisable(true)
    setAttConfigId('');
    setAttExcDocumentFile('');
    setAttExcDocumentFilePath('');
  }

  const handleAttendceExceptionType = (data: any) => {
    setAttConfigId(data)
  }

  const attExcDocumentUpload = (e: any) => {
    const file: any = e.target.files[0];
    setNewAttachement(true);
    if (file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      const image_as_files: any = file;
      setAttExcDocumentFile(image_as_files);
      setAttExcDocumentFilePath(image_as_base64);
    } else {
      setIsPDF(true);
      setPDFName(file?.name);
      setAttExcDocumentFile(file);
    }
  };

  const handleViewAttachment = (url: any) => {
    setOpenViewFullPicModal(true)
    setAttachmenUrl(url)
  }


  return (
    <Grid
      container
      style={{
        height: '100%',
        marginTop: '4em',
        width: '100vw',
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          marginTop: isHRView ? '-3em' : '',
          marginLeft: '-1em',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#F5F5FA',
            width: '100%',
            height: 'auto',

            marginRight: i18n?.language == 'ar' ? '6em' : '',
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{
                display: 'flex',
                padding: '20px',
                flexWrap: 'wrap',
              }}
            >
              <Box>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    sx={{
                      width: '92vw',
                      marginTop: '1.75em',
                      padding: '1em',
                    }}
                  >
                    <Box
                      style={{
                        width: 'auto',
                        height: 'auto',
                        background: '#FFFFFF 0% 0% no-repeat padding-box',
                        borderRadius: '10px',
                        opacity: '1',
                        display: 'flex',
                        flexDirection: 'row',
                        paddingTop: '1em',
                        paddingBottom: '1em',
                        paddingLeft: '1em',
                        paddingRight: '1em',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.header,
                          color: themes.blackDefault,
                          fontWeight: 'bold',
                        }}
                      >
                        {trans('Attendance Exception')}
                      </Typography>
                    </Box>
                    <Box
                      style={{
                        width: 'auto',
                        height: 'auto',
                        background: '#FFFFFF 0% 0% no-repeat padding-box',
                        borderRadius: '10px',
                        opacity: '1',
                        paddingTop: '1em',
                        paddingBottom: '1em',
                        paddingLeft: '1em',
                        paddingRight: '1em',
                        marginTop: '1em',
                      }}
                    >
                      <Grid
                        container
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          flexWrap: 'nowrap',
                          marginTop: '1em',
                          marginBottom: '1em',
                          marginLeft: '0.1em',
                          marginRight: '3em',
                        }}
                        spacing={2}
                      >
                        <SearchComponent
                          onChange={(e: any) => setDebounceTerm(e)}
                          padding={'10px'}
                          width={'15%'}
                        />
                        <CustomAddButton
                          btnLabel={trans('Add Attendance Exception')}
                          onClick={() => closeModal(true)}
                        />
                      </Grid>
                      <Grid>
                        <Grid item>
                          <Box
                            className="ar_table"
                            sx={{
                              '& .header': {
                                backgroundColor: '#F5F5F5',
                                position: 'sticky',
                              },
                              width: '100%',
                              height: '450px'
                            }}
                          >
                            <DataGrid
                              sx={{
                                color: '#081735',
                                font: 'normal normal normal 14px/24px Lato;',
                              }}
                              localeText={isRTL ? arabicDataGrid : undefined}
                              disableExtendRowFullWidth
                              disableSelectionOnClick
                              disableColumnMenu
                              // autoHeight
                              disableColumnFilter
                              rows={row_data}
                              columns={tableColumns}
                              rowCount={totalCount}
                              pageSize={rowPerPage}
                              page={page}
                              paginationMode="server"
                              onPageChange={(newPage) =>
                                handlePageChange(newPage)
                              }
                              onPageSizeChange={(newPageSize) =>
                                handleRowsPerPageChange(newPageSize)
                              }
                              rowsPerPageOptions={[10, 25, 50, 100]}
                              componentsProps={{
                                pagination: {
                                  labelRowsPerPage: trans('Rows per page'),
                                },
                              }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <CustomModal
        isModalOpen={openModel}
        overflowY="auto"
        modalHeight="630px"
        modalWidth="400px"
      >
        <ModalHeader
          modal={{ modal_title: trans(`${modelHeaderName} Attendance Exception`) }}
          wrap={'nowrap'}
          closeModal={handleClose}
        />
        <Compdirection>
          <Grid
            container
            spacing={2}
            style={{
              marginTop: '5px',
            }}
          >
            <Grid item xs={12}>
              <Box
                style={{
                  height: 'auto',
                  border: '1px solid #0000001F',
                  borderRadius: '15px',
                  padding: '20px',
                  overflowY: 'auto',
                }}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <CustomAutoComplete
                      label={trans('Attendance Exception Type')}
                      value={disableField ? attConfigName : attConfigId}
                      disable={disableField}
                      options={_.map(attExceptionConfig, (emp: any) => ({
                        id: emp.id,
                        label: emp.name,
                      }))}
                      onChange={(event: any, newValue: any) => {
                        handleAttendceExceptionType(newValue);
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      marginTop: '1em',
                      marginBottom: '1em',
                    }}
                  >
                    <div className="flex items-center justify-between w-full mb-3">
                      <Typography className="text-sm" style={{
                        color: !date ? '#8181A5' : '#7C0E6F',
                      }}>{trans('Date')}</Typography>
                      <div className="flex items-center w-full">
                        <DatePickerInput
                          width={'360px'}
                          defaultValue={date}
                          value={date}
                          disabled={disableField}
                          supportUTC={false}
                          disableFuture={attExceptionConfig?.find((item: any) => item?.id == attConfigId?.id)?.allow_future_date ? false : true}
                          onChange={handleDateChange}
                        />
                      </div>
                    </div>
                    {!fieldDisable && shiftDetails?.shift &&
                      <Box style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",

                      }}>
                        <Typography>{translate('timezone')}</Typography>
                        <Typography style={{
                          color: colors.primary
                        }}>
                          {shiftDetails?.shift.timezone}
                        </Typography>
                      </Box>
                    }
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{

                    }}
                  >
                    {!fieldDisable && shiftDetails ? (
                      <Box style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        marginBottom: "12px"
                      }}>
                        <Typography>{translate('Shift')}</Typography>
                        <Typography style={{
                          color: colors.primary
                        }}>
                          {shiftDetails?.shift.code}
                        </Typography>
                      </Box>
                    ) : fieldDisable && error_noshift.length > 0 ? (
                      <Box style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",

                      }}>
                        <Typography>{translate('Shift')}</Typography>
                        <Typography
                          style={{
                            color: colors.primary
                          }}
                        >No Shift Assigned.</Typography>
                      </Box>
                    ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sx={{
                      marginTop: '1em',
                      marginBottom: '1em',
                    }}
                  >
                    <Box>
                      <Typography
                        className="input-box-title10"
                        style={{
                          color: startAt ? '#7C0E6F' : '#8181A5',
                        }}
                      >
                        {trans('Start at')}
                      </Typography>
                    </Box>
                    <Box>
                      <TimePickerInput
                        value={startAt}
                        disabled={disableField}
                        width={'160px'}
                        onChange={(newValue) => {
                          handleChangeStartAt(newValue);
                        }}
                      />
                      <i
                        className="las la-clock"
                        style={{
                          fontSize: '1em',
                          color: colors.grey,
                        }}
                      ></i>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sx={{
                      marginTop: '1em',
                      marginBottom: '1em',
                    }}
                  >
                    <Box className="shadowBox">
                      <Typography
                        className="input-box-title10 text-base"
                        style={{
                          color: endAt ? '#7C0E6F' : '#8181A5',
                        }}
                      >
                        {trans('End at')}
                      </Typography>
                    </Box>
                    <Box className="shadowBox">
                      <TimePickerInput
                        value={endAt}
                        disabled={disableField}
                        width={'160px'}
                        onChange={(newValue) => {
                          handleChangeEndAt(newValue);
                        }}
                      />
                      <i
                        className="las la-clock"
                        style={{
                          fontSize: '1em',
                          color: colors.grey,
                        }}
                      ></i>
                    </Box>
                  </Grid>
                  <Grid item xs={12} style={{
                    marginTop: '1em'
                  }}>
                    <CustomTextField
                      type="string"
                      multiline={true}
                      disabled={disableField}
                      label={trans('Remarks')}
                      placeholder={trans('Write Remarks')}
                      value={remarks}
                      onChange={(e: any) => setRemarks(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6} style={{ marginTop: '0.5em' }}>
                    <DropAndSelect
                      upload={attExcDocumentUpload}
                      src={attExcDocumentFilePath}
                      isPDF={isPDF}
                      pdfName={pdfName}
                      onDelete={() => {
                        setPDFName('');
                        setIsPDF(false);
                        setAttExcDocumentFilePath('');
                        setNewAttachement(false);
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginTop: '35px' }} />
        </Compdirection>
        {!disableField && (
          <ModalFooter
            isSubmitting={loading}
            submitButtonDisable={submitDisable}
            onClickSubmit={handleSubmit}
            onClickCancel={handleClose}
          />
        )}
      </CustomModal>
      <CustomModal
        isModalOpen={isModalOpen}
        modalHeight="755px"
        modalWidth="auto"
      >
        <ModalHeader
          modal={{ modal_title: trans('Attendance Exception Details') }}
          closeModal={() => closeModal2(false)}
        />
        <Grid
          container
          style={{
            marginTop: '35px',
          }}
        >
          <Grid item xs={7} className="left-grid">
            <Grid container style={{ padding: '10px' }}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Attendance Exception Details')}
                </Typography>
              </Grid>

              <CardContentTile
                textWrap={'nowrap'}
                tile_key={trans('Attendance Exception Type')}
                tile_value={fullData?.name}
              />
              <CardContentTile
                tile_key={trans('Date')}
                tile_value={<DateField value={fullData?.date} format={baseDateFormatting} />}
              />
              <CardContentTile
                tile_key={trans('Start At')}
                tile_value={<DateField value={fullData?.start_time} format={baseTimeFormatting} />}
              />
              <CardContentTile
                tile_key={trans('End At')}
                tile_value={fullData?.end_time ? <DateField value={fullData?.end_time} format={baseTimeFormatting} /> : '--:--'}
              />
              <CardContentTile
                tile_key={trans('Attachment')}
                tile_value={<i className='las la-eye' style={{ cursor: 'pointer' }} onClick={() => handleViewAttachment(fullData?.attachment)}></i>}
              />
              <CardContentTile
                tile_key={trans('Remarks')}
                tile_value={fullData?.remarks}
              />
            </Grid>
          </Grid>
          <Grid item xs={1}>
            {' '}
          </Grid>
          <Grid item xs={4} className="right-grid">
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Tracking Details')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <VerticalBarController
                  instanceId={fullData?.workflow_instance_id}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box style={{ marginTop: '35px' }} />
        {/* <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal2(false);
        }}
        isSubmitButton={false}
      /> */}
      </CustomModal>
      <CustomModal
        isModalOpen={openViewFullPicModal}
        overflowY="auto"
        modalHeight="630px"
        modalWidth="450px"
      >
        <ModalHeader
          modal={{ modal_title: trans('View Attachment') }}
          closeModal={() => {
            setOpenViewFullPicModal(false)
            setAttachmenUrl('')
          }}
        />
        <ImageModelView
          url={attachmentUrl}
          isOpen={openViewFullPicModal}
          onClose={() => {
            setOpenViewFullPicModal(false)
            setAttachmenUrl('')
          }}
          isAttachmentSigned={true}
        />
      </CustomModal>
    </Grid>
  );
};

export default AttendanceexceptionPresenter;
